import React from 'react';
import './styles.scss';
import ICalendarLink from "react-icalendar-link";

const CalendarInvitationCTA: React.FC<any> = ({ calendarEventData }) => {

  let addCalendarEventCTA = false;
  if (calendarEventData && Object.keys(calendarEventData).length > 0 && Object.getPrototypeOf(calendarEventData) === Object.prototype) {
    addCalendarEventCTA = true;
  }

  const event = {
    title: calendarEventData.calendarEventSummary,
    description: calendarEventData.calendarEventDescription,
    startTime: calendarEventData.calendarEventDate,
    url: calendarEventData.calendarEventUrl,
  }

  return (
    <>
      {addCalendarEventCTA ? (
          <div className={"dynamic-cta calendar-event-cta " + calendarEventData.componentClass}>
            {
              <style dangerouslySetInnerHTML={{__html:`
                  .`+calendarEventData.componentClass+` .cta-base-color {
                      background: `+calendarEventData.ctaBaseColor+`;
                      border-color: `+calendarEventData.ctaBaseColor+`;
                      color: `+calendarEventData.ctaTextColor+`;
                    }
                  .`+calendarEventData.componentClass+` .cta-base-color:hover {
                      background: `+calendarEventData.ctaButtonHoverColor+`;
                      border-color: `+calendarEventData.ctaButtonHoverColor+`;
                      color: `+calendarEventData.ctaTextHoverColor+`;
                    }
                `}}
              />
            }
            <div className="btn cta-base-color">
              <ICalendarLink event={event}>
                {calendarEventData.ctaText}
              </ICalendarLink>
            </div>
          </div>
        ) : null
      }
    </>
  );
};

export default CalendarInvitationCTA;